import { DeepOmitType } from "@website/utils/deep-omit/deep-omit.types";
import { isFilled } from "@website/utils/is-filled";
import filter from "lodash-es/filter";
import isArray from "lodash-es/isArray";
import isEmpty from "lodash-es/isEmpty";
import isFunction from "lodash-es/isFunction";
import isPlainObject from "lodash-es/isPlainObject";
import map from "lodash-es/map";
import mapValues from "lodash-es/mapValues";
import pickBy from "lodash-es/pickBy";

export const deepOmit: DeepOmitType = (value, filterFunction) => {
  filterFunction = isFunction(filterFunction) ? filterFunction : isFilled;
  if (isArray(value)) {
    const newValue = filter(map(value, deepOmit), filterFunction);
    return (isEmpty(newValue) ? undefined : newValue) as typeof value;
  }
  if (isPlainObject(value)) {
    const newValue = pickBy(
      mapValues(value as object, deepOmit),
      filterFunction
    );
    return (isEmpty(newValue) ? undefined : newValue) as typeof value;
  }
  return filterFunction(value) ? value : undefined;
};
